/* Product content only. No product form, personalization or cart side effects. */
(function () {
  'use strict';
  if (customElements.get('hah-product-story')) return;

  function enhanceQuestions(container) {
    if (container.dataset.hahStoryEnhanced) return;
    var content = container.querySelector('.metafield-rich_text_field') || container;
    var children = Array.from(content.childNodes);
    if (!children.some(function (node) { return node.nodeType === 1 && node.tagName === 'H3'; })) return;
    var fragment = document.createDocumentFragment();
    var index = 0;
    while (index < children.length) {
      var heading = children[index];
      if (heading.nodeType !== 1 || heading.tagName !== 'H3') {
        fragment.appendChild(heading); index += 1; continue;
      }
      var answer = [];
      index += 1;
      while (index < children.length && !(children[index].nodeType === 1 && children[index].tagName === 'H3')) {
        answer.push(children[index]); index += 1;
      }
      var question = heading.textContent.trim();
      var hasAnswer = answer.some(function (node) { return node.textContent.trim() || node.nodeType === 1 && node.querySelector('img,video'); });
      if (!question || !hasAnswer) {
        fragment.appendChild(heading);
        answer.forEach(function (node) { fragment.appendChild(node); });
        continue;
      }
      var details = document.createElement('details');
      details.className = 'hah-story-question';
      var summary = document.createElement('summary');
      summary.textContent = question;
      var body = document.createElement('div');
      body.className = 'hah-story-answer';
      answer.forEach(function (node) { body.appendChild(node); });
      details.appendChild(summary); details.appendChild(body); fragment.appendChild(details);
    }
    content.replaceChildren(fragment);
    container.dataset.hahStoryEnhanced = 'true';
  }

  class ProductStory extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-hah-story-faq]').forEach(enhanceQuestions);
      if (this._hahStoryConnected) return;
      this._hahStoryConnected = true;
      this._onPlay = function (event) {
        if (event.target.tagName !== 'VIDEO') return;
        document.querySelectorAll('hah-product-story video').forEach(function (video) {
          if (video !== event.target && !video.paused) video.pause();
        });
      };
      this._onError = function (event) {
        var video = event.target;
        if (video.tagName !== 'VIDEO' || video.parentElement.querySelector('.hah-story-video-error')) return;
        var message = document.createElement('p');
        message.className = 'hah-story-video-error'; message.setAttribute('role', 'status');
        message.textContent = 'This video is unavailable right now. Please try again later.';
        video.parentElement.appendChild(message);
      };
      this.addEventListener('play', this._onPlay, true);
      this.addEventListener('error', this._onError, true);
    }
    disconnectedCallback() {
      this.removeEventListener('play', this._onPlay, true);
      this.removeEventListener('error', this._onError, true);
      this._hahStoryConnected = false;
    }
  }
  customElements.define('hah-product-story', ProductStory);
}());
